import { endpointsViews } from "../endpoints/endpointsViews";
import { authenticatedAxios } from "../fetcher";

export type ViewImageSize = "full" | "thumbnail";

function viewImageEndpoint(
  projectId: number,
  snapshotId: string,
  annotatedSnapshotId: string | undefined,
  size: ViewImageSize,
) {
  if (size === "thumbnail") {
    return annotatedSnapshotId
      ? endpointsViews.annotatedSnapshotThumbnail(
          projectId,
          snapshotId,
          annotatedSnapshotId,
        )
      : endpointsViews.snapshotThumbnail(projectId, snapshotId);
  }
  return annotatedSnapshotId
    ? endpointsViews.annotatedSnapshot(
        projectId,
        snapshotId,
        annotatedSnapshotId,
      )
    : endpointsViews.snapshot(projectId, snapshotId);
}

export async function fetchViewImage(
  projectId: number,
  snapshotId: string,
  annotatedSnapshotId: string | undefined,
  size: ViewImageSize,
): Promise<Blob | null> {
  try {
    const response = await authenticatedAxios.get<Blob>(
      viewImageEndpoint(projectId, snapshotId, annotatedSnapshotId, size),
      { responseType: "blob" },
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
